// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './story/'
import ElementUI from 'element-ui'
import clickoutside from './plugins/clickoutside'
Vue.use(ElementUI);
import './config/options'
import components from './components/'
// import './assets/fonts/font_protal_company/iconfont.css'
import './assets/fonts/font_protal_company2/iconfont.css'

import * as getData from './service/getData'


Object.keys(components).forEach((key) => {
  var name = key.replace(/(\w)/, (v) => v.toUpperCase()) // 首字母大写
  Vue.component(`v${name}`, components[key])
})


Vue.prototype.$checkPermissions = (val) => {

  // if (!sessionStorage['permissions']) { //todo 调试时打开
  //   return true;
  // }
  return JSON.parse(sessionStorage['permissions']).indexOf(val) > -1
};

router.beforeEach((to, from, next) => {
  /* document.title = sessionStorage.getItem('channelNickname');*/
  if (to.path == '/login') {
    sessionStorage.clear();
    console.log("login", to.path);
    next()
  } else {
    console.log("check");
    //检查登录状态
    getData.checkLogin().then(res => {
      if (res.data.code == 'success') {
        next()
      } else {
        next({path: '/login'})
      }
    })
  }
});

Vue.directive('clickoutside',//自定义点击元素范围外触发的指令
  clickoutside
);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js